import { Component } from '@angular/core';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { NavController, NavParams, ToastController, LoadingController, ModalController, Modal} from 'ionic-angular';

import { Schedule, Master, Notes, Dokumen } from '@providers/index';

import { DetailImagePage } from '../';

@Component({
  selector: 'page-detail-schedule',
  templateUrl: 'page.html'
})
export class DetailSchedulePage {
 
  form = {
    id            : '',
    activity_type : '',
    activity      : '',
    date_start    : '',
    date_end      : '',
    description   : '',
    pic_name      : '',
    pic_id        : '',
    project_id    : '',
    state_id      :  1,
    stage_id      : '',
  };
  now_state_id  = 1;
  note          = '';
  listState  :any = [];
  project    :any = {};
  loading    :any;
  notes      :any = [];
  images     :any = [];
  images_new :any = [];
  img_url  ='';
  
  constructor(
    public navCtrl    : NavController,
    public navParams  : NavParams,
    private toastCtrl : ToastController,
    public loadingCtrl: LoadingController,
    public modalCtrl  : ModalController,
    public scheduleApi: Schedule,
    public notesApi   : Notes,
    public masterApi  : Master,
    public dokumenApi : Dokumen,
    public camera     : Camera
  ) {

    this.getState();
    this.project = this.navParams.get('project');
    if(this.navParams.get('rec')!=undefined){
      this.form = this.navParams.get('rec');
      this.now_state_id = this.form.state_id;
      this.getNotes();
    }

    this.img_url = this.dokumenApi.file_url;
    this.getImagesByID();
  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  getState(){
    this.showLoading();
    let params = {};
    this.masterApi.state(params).subscribe((resp:any) => {
      this.listState = resp.data;
      this.loading.dismiss();
    });
  }

  getNotes(){
    let params = {
      project_id : this.project.id,
      related_id : this.form.id,
      related_to : 'Schedule'
    }
    this.notesApi.get(params).subscribe((resp:any) => {
      this.notes = resp.data;
    });
  }

  save(){    
    this.showLoading();
    this.form.project_id = this.project.id;
    let params:any = this.form;

    params.dokument_id = '';
    let dok_arr = [];
    this.images_new.forEach(el => {
      if(el.project_id==undefined){
        dok_arr.push(el.dokument_id);
      }
    });
    params.dokument_id = dok_arr.join(',');
    params.dokument_type = 'end';

    this.scheduleApi.post(params).subscribe((resp:any) => {
      this.loading.dismiss();
      if(this.form.state_id!=1 || this.note!=''){
        this.add_note();
      }else{
        this.presentToast(resp.msg);
        this.navCtrl.pop();
      }
    },(err) => {
      this.presentToast('Error');
      this.loading.dismiss();
    });
  }

  add_note(){    
    this.showLoading();
    let params = {
      project_id    : this.project.id,
      note          : this.note,
      related_to    : 'Schedule',
      related_id    : this.form.id,
      related_notes : this.form.activity
    };
    this.notesApi.post(params).subscribe((resp:any) => {
      this.loading.dismiss();
      this.presentToast(resp.msg);
      this.navCtrl.pop();
    },(err) => {
      this.presentToast('Error');
      this.loading.dismiss();
    });
  }

  getImagesByID(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params : any =  {
      schedule_id : this.form.id
    };
    let get : any;
    get = this.scheduleApi.getScheduleImage(params);
      get.subscribe((resp:any) => {
        if(resp.data.length>0){
          this.images = resp.data;
        }
        loading.dismiss();
      }, (err) => {
        loading.dismiss();
      });
  }

  takePicture(camera=1){
    const options: CameraOptions = {
      quality        : 25,
      destinationType: this.camera.DestinationType.DATA_URL,
      targetWidth    : 1024,
      sourceType     : camera
    }
    
    this.camera.getPicture(options).then((imageData) => {
     // imageData is either a base64 encoded string or a file URI
     // If it's base64 (DATA_URL):
     let base64Image = 'data:image/jpeg;base64,' + imageData;
     this.save_image(base64Image);
    }, (err) => {
     // Handle error
    });
  }

  save_image(img){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = {img: img};
    this.dokumenApi.post(params).subscribe((resp:any) => {
      resp.data.dokument_id=resp.data.id;
      resp.data.id         ='';
      this.images.push(resp.data);
      this.images_new.push(resp.data);
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  viewImage(rec) {
    let profileModal = this.modalCtrl.create(DetailImagePage, { 
      url_image : this.img_url+rec.generated_name,
      detail    : rec,
      edit      : true
    });
    profileModal.present();
    console.log("Image params => ", rec);
  }
}



// WEBPACK FOOTER //
// ./src/pages/project_mobile/detail_schedule/page.ts